import React, {useState } from "react";
import { Rating } from "react-simple-star-rating";

export default function Avis({avis={note:2.5,text:'',auther:'Vous'},SendAvis=()=>{}, isNew=false})
{
    const [_avis,setAvis] = useState(avis)

    if(isNew)
    {
        return(<div style={{padding:'10px',marginBottom:'30px'}}>
                    <div style={{marginLeft:'20px'}}>
                        <span style={{marginRight:'20px'}}>{_avis.auther} :</span> 
                        <Rating initialValue={_avis.note} size={15} onClick={e=>{setAvis({..._avis,note:e})}} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} />
                    </div>
                    <textarea onChange={(e)=>{setAvis({..._avis,text:e.target.value})}} placeholder="Que pensez-vous de ce produit ?" id="textbox" style={{width:'95%',border:'1px solid lightgray',borderRadius:'5px',textAlign:'center',minHeight:'70px'}}></textarea>
                    <input onClick={e=>{SendAvis(_avis)}} type='button' value={'Envoyer'} style={{backgroundColor:'skyblue',border:'none',margin:'10px 30px 10px 10px',borderRadius:'5px',padding:'5px 10px 5px 10px',float:'inline-end'}}/>
            </div>);
    }
    else
    {
        return(
        <div style={{marginTop:"10px"}}>
            <div style={{marginLeft:'10px'}}>
                <span style={{marginRight:'20px'}}>{_avis.auther} :</span> 
                <Rating size={15} readonly={true} initialValue={_avis.note} onClick={e=>{}} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={(index)=>{}} />
            </div>
            <p id="textbox" style={{borderRadius:'5px',fontSize:'small',marginTop:'2px',padding:'10px',color:'gray',border:'1px solid lightgray'}}>{_avis.text}</p>
        </div>);
    }
}